// @tenorlab/nuxt-dashboard-pro
// file: app/models/navigation/navigation.utils.ts
import type { INavigationItem } from './interfaces'

const navigationItemSerializableProps = [
  'id',
  'name',
  'icon',
  'href',
  'selected',
  'hidden',
  'isExpanded',
  'parentId',
  'isParent',
  'badgeValue',
  'badgeCategory',
]

const shallowCloneNavigationItem = (x: INavigationItem): INavigationItem => {
  const clone = JSON.parse(JSON.stringify(x, navigationItemSerializableProps))
  clone.children = []
  return clone
}

export const filterMenuItems = (items: INavigationItem[]): INavigationItem[] => {
  const filtered = items
    .filter((x) => !x.hidden)
    .map((x) => {
      const clone = shallowCloneNavigationItem(x)
      const childrenCount = (x.children || []).length
      if (childrenCount > 0) {
        clone.children = (x.children || [])
          .filter((child) => !child.hidden)
          .map((child) => shallowCloneNavigationItem(child))
      }
      return clone
    })

  return filtered
}
